import { PureComponent } from "react";
import { RelayProp, createFragmentContainer, graphql, commitMutation } from "react-relay";
import Button from "~/components/shared/Button";
import RecoveryCodeList from "~/components/RecoveryCodeList";

type Props = {
  relay: RelayProp;
  totp: any;
};

type State = {
  generatingNewCodes: boolean;
  newCodesAvailable: boolean;
};

class RecoveryCodes extends PureComponent<Props, State> {
  state = {
    generatingNewCodes: false,
    newCodesAvailable: false,
  };

  render() {
    let contents;
    if (this.state.newCodesAvailable) {
      contents = this.renderNewCodesSection();
    } else {
      contents = this.renderGenerateSection();
    }

    return <div className="p-5">{contents}</div>;
  }

  renderGenerateSection() {
    return (
      <>
        <h2 className="semi-bold m-0 mb-5 text-xl">Generate New Recovery Codes</h2>
        <p>
          When you generate new recovery codes, your previous codes will no longer be valid. Please
          ensure you save a copy of your new recovery codes after they’ve been generated.
        </p>
        <Button
          className="w-full"
          theme="primary"
          onClick={this.handleRegenerateRecoveryCodes}
          loading={this.state.generatingNewCodes && "Generating New Recovery Codes…"}
          disabled={this.state.generatingNewCodes}
        >
          Generate New Recovery Codes
        </Button>
      </>
    );
  }

  renderNewCodesSection() {
    return (
      <>
        <div className="green border-green mb-4 rounded border p-4">
          <div className="font-semibold">Here are your new recovery codes.</div>
          <div>
            Your previous codes have been removed. Please make sure you store them in a safe place
          </div>
        </div>

        <div className="mt-4">
          <RecoveryCodeList recoveryCodes={this.props.totp.recoveryCodes} />
        </div>
      </>
    );
  }

  handleRegenerateRecoveryCodes = () => {
    this.setState({ generatingNewCodes: true });

    commitMutation(this.props.relay.environment, {
      mutation: graphql`
        mutation RecoveryCodesRegenerateMutation($input: TOTPRecoveryCodesRegenerateInput!) {
          totpRecoveryCodesRegenerate(input: $input) {
            totp {
              id
              recoveryCodes {
                id
                codes {
                  code
                  consumed
                }
              }
            }
          }
        }
      `,
      variables: { input: { totpId: this.props.totp.id } },
      onCompleted: () => {
        this.setState({ newCodesAvailable: true });
      },
      onError: (error) => {
        alert(error);
      },
    });
  };
}

export default createFragmentContainer(RecoveryCodes, {
  totp: graphql`
    fragment RecoveryCodes_totp on TOTP {
      id
      recoveryCodes {
        id
        ...RecoveryCodeList_recoveryCodes
        codes {
          code
          consumed
        }
      }
    }
  `,
});
